import { Nullable } from 'modules/types/common';
import { consumerIdSelector } from 'store/profile/selectors';
import { Consumer, Grantor } from 'store/profile/types';
import ReduxStoreContainer from 'store/ReduxStoreContainer';

export const isPrimaryUser = (user: Nullable<Consumer | Grantor>): boolean => {
  const state = ReduxStoreContainer.getState();
  const consumerId = consumerIdSelector(state);
  return consumerId === user?.consumerId;
};
